import { GetLocalizationEffects } from './get-localization.effects';
import { RoutingEffects } from './routing.effects';
import { ToolEffects } from './tool.effects';

export const CoreEffects = [GetLocalizationEffects, ToolEffects, RoutingEffects];
